import { Box, Grid } from 'grommet';
import styled from 'styled-components';

export const HideInPrint = styled(Box)`
    @media print {
        display: none !important;
    }
`;

export const VisibleOnlyInPrint = styled(Box)`
    display: none !important;
    @media print {
        display: initial !important;
    }
`;

export const PageBreak = styled.span`
    .break-after {
        display: block;
        page-break-after: always;
        position: relative;
    }

    .break-before {
        display: block;
        page-break-before: always;
        position: relative;
    }
    @media print {
        page-break-before: always;
        page-break-after: always;
    }
`;

export const DisplayBlockInPrint = styled(Box)`
  @media print {
      display: block !important;
      margin-top: 0.5mm;

      table th span {
        line-height: 1.4;
      }
      
      table { page-break-inside:auto }
      
      td div {
        display: block !important;
      }
      
      tr, td {
        page-break-inside: avoid !important; 
        page-break-after: auto !important;
      } 
      
      td > div {
        display: inline-block !important;
        height: 100%;
        page-break-inside: avoid !important;
      }
  }
`;

export const PrintableGrid = styled(Grid)`
    @media print {
        display: table !important;
        page-break-inside: avoid !important; 
        page-break-after: auto !important;
        
        > div {
            display: table-cell !important;
            width: ${ props => 100/(props?.columns?.count || props?.columns?.length || 1)}%;
            page-break-inside: avoid !important; 
            page-break-after: auto !important;
            
            > span {
                display: block;
            }
            
            .inline {
                display: inline-block !important;
            }
        }
    }
`